module.exports = __webpack_public_path__ + "img/KeksAufessen.b8fc4bd1.jpg";